import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_ctx.isClient)
    ? (_openBlock(), _createBlock(_component_apexchart, {
        key: 0,
        type: "area",
        height: "325",
        options: _ctx.missedCalls,
        series: _ctx.calls
      }, null, 8, ["options", "series"]))
    : _createCommentVNode("", true)
}